import "@fortawesome/fontawesome-free/css/all.min.css";
import { useState } from "react";

function Webwasa() {
  const [activeTab, setActiveTab] = useState("methodology");

  return (
    <div>
      {/* -- Banner sec ---- */}
      <div className="page-banner-area">
        <h2>Services</h2>
        <div className="breadcrumbs-services">
          <ul>
            <li>
              <a href="/">Home</a>
            </li>
            <li> Source Code Review (SCR)</li>
          </ul>
        </div>
      </div>
      {/* -- Banner sec ---- */}

      {/* ---- About service section ----- */}
      <div className="about-services-wrap">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              {/* headings */}
              <div className="heading-in mb-5">
                <h1>Source Code Review (SCR)</h1>
                <p>
                  <b className="sub-heading">Introduction</b>
                  <br />
                  Your application’s source code is the foundation of its
                  security and reliability. Even the most advanced applications
                  can harbor hidden vulnerabilities at the code level — from
                  insecure functions to overlooked logic flaws. Source Code
                  Review (SCR) is a systematic examination of your application’s
                  source code to uncover vulnerabilities that automated scanners
                  often miss. By combining manual analysis with automated tools,
                  we ensure that your codebase is secure, efficient, and
                  compliant before it reaches production.
                </p>
              </div>

              {/* Why It Matters */}
              <div className="service-card-heading">
                <h1>Why It Matters</h1>
              </div>
              <div className="services-cards-wp">
                {[
                  {
                    icon: "fa-arrows-down-to-people",
                    title: "Proactive Security",
                    desc: "Identify vulnerabilities at the code level before attackers can exploit them.",
                  },
                  {
                    icon: "fa-database",
                    title: "Compliance Assurance",
                    desc: "Meet industry standards such as OWASP, PCI DSS, ISO 27001, and HIPAA.",
                  },
                  {
                    icon: "fa-shield-halved",
                    title: "Cost Savings",
                    desc: "Fixing flaws in early development is far cheaper than addressing breaches later.",
                  },
                  {
                    icon: "fa-table",
                    title: "Code Quality",
                    desc: "Improve maintainability, readability, and efficiency of code.",
                  },
                  {
                    icon: "fa-business-time",
                    title: "Reduced Business Risk",
                    desc: "Prevent exploitation of hidden flaws that can compromise customer trust and revenue.",
                  },
                  {
                    icon: "fa-business-time",
                    title: "Secure SDLC",
                    desc: "Builds a culture of security into the software development lifecycle.",
                  },
                ].map((item, i) => (
                  <div className="service-box" key={i}>
                    <div className="service-icon">
                      <i className={`fa-solid ${item.icon}`}></i>
                    </div>
                    <div className="service-card-content">
                      <h3>{item.title}</h3>
                      <p>{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/* Tabs */}
              <div className="tab-pill-sec-main">
                <div className="tab-inner-contain">
                  <ul className="nav nav-pills">
                    {[
                      { id: "methodology", label: "Methodology" },
                      { id: "keybenefits", label: "Key Benefits" },
                      { id: "deliverables", label: "Deliverables" },
                    ].map((tab) => (
                      <li className="nav-item" key={tab.id}>
                        <button
                          className={`nav-link${activeTab === tab.id ? " active" : ""}`}
                          onClick={() => setActiveTab(tab.id)}
                        >
                          {tab.label}
                        </button>
                      </li>
                    ))}
                  </ul>

                  <div className="tab-content">
                    {/* Methodology */}
                    <div
                      className={`tab-pane fade${activeTab === "methodology" ? " show active" : ""}`}
                      role="tabpanel"
                    >
                      <p>
                        Our Source Code Review methodology blends automated
                        scanning with manual deep-dive analysis to ensure
                        accuracy and context-driven results.
                      </p>
                      <ul>
                        <li><b>Scope Definition :-</b> Identify codebase, programming languages, frameworks, and business-critical modules.</li>
                        <li><b>Automated Analysis :-</b> Use industry-leading tools to flag known vulnerability patterns.</li>
                        <li><b>Manual Review :-</b> Conduct line-by-line inspection to catch logic flaws, insecure coding practices, and hidden risks.</li>
                        <li><b>Risk Prioritization :-</b> Categorize vulnerabilities by severity, exploitability, and business impact.</li>
                        <li><b>Remediation Guidance :-</b> Provide actionable fixes aligned with secure coding standards.</li>
                        <li><b>Re-Validation :-</b> Verify fixes and ensure code is hardened against future risks.</li>
                      </ul>
                    </div>

                    {/* Key Benefits */}
                    <div
                      className={`tab-pane fade${activeTab === "keybenefits" ? " show active" : ""}`}
                      role="tabpanel"
                    >
                      <ul>
                        <li>Identify hidden security flaws early in development.</li>
                        <li>Enhance overall code quality and maintainability.</li>
                        <li>Ensure compliance with security and regulatory standards.</li>
                        <li>Reduce future costs by addressing vulnerabilities at the root.</li>
                        <li>Empower developers with secure coding practices.</li>
                        <li>Strengthen customer trust by ensuring application integrity.</li>
                      </ul>
                    </div>

                    {/* Deliverables */}
                    <div
                      className={`tab-pane fade${activeTab === "deliverables" ? " show active" : ""}`}
                      role="tabpanel"
                    >
                      <p>At the end of a Source Code Review, you will receive:</p>
                      <ul>
                        <li><b>Detailed Vulnerability Report :-</b> Listing issues with severity ratings and affected code segments.</li>
                        <li><b>Secure Code Analysis :-</b> Insights into insecure coding patterns and logic flaws.</li>
                        <li><b>Remediation Guidelines :-</b> Actionable steps to fix vulnerabilities with code snippets/examples.</li>
                        <li><b>Executive Summary :-</b> A business-focused overview for leadership and stakeholders.</li>
                        <li><b>Re-Validation Report :-</b> Confirmation that remediated code is now secure.</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              {/* Our Approach */}
              <div className="our-approach-sec-main">
                <div className="container">
                  <h3>Our Approach</h3>
                  <p>
                    We don’t just scan your code — we understand your
                    application architecture and business context to deliver
                    meaningful security improvements.
                  </p>
                  <ul>
                    <li><b>Hybrid Review Model :-</b> Automated tools + expert manual review.</li>
                    <li><b>Framework-Specific Expertise :-</b> Proficiency in Java, .NET, Python, PHP, JavaScript, C/C++, Ruby, Go, and more.</li>
                    <li><b>Business Logic Coverage :-</b> Detect vulnerabilities that scanners often miss.</li>
                    <li><b>Secure Coding Standards :-</b> Recommendations aligned with CWE, OWASP, and CERT guidelines.</li>
                    <li><b>Developer Enablement :-</b> Developer workshops and knowledge transfer to build secure coding practices.</li>
                    <li><b>Proven Experience :-</b> Years of securing critical applications across fintech, healthcare, e-commerce, and enterprise domains.</li>
                  </ul>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      {/* ---- About service section ----- */}
    </div>
  );
}

export default Webwasa;
